import {
  FaceToFaceTreatmentKeywordsQuery,
  MedicalCategoriesQuery,
  MedicalCategoryIconType,
} from '@/types/bff/gql-schema';
import { HospitalTreatmentVo, MedicalCategoryVo } from '@/types/hospital';

const getCategoryIconType = (
  iconType: MedicalCategoryIconType,
): 'ANIMATION' | 'PLAIN_IMAGE' => {
  switch (iconType) {
    case MedicalCategoryIconType.Animation:
      return 'ANIMATION';
    case MedicalCategoryIconType.PlainImage:
    default:
      return 'PLAIN_IMAGE';
  }
};

export const parseMedicalCategoriesVo = (
  data: MedicalCategoriesQuery,
): Array<MedicalCategoryVo> => {
  return data.medicalCategories.map((data) => {
    return {
      ...data,
      iconType: getCategoryIconType(data.iconType),
    };
  });
};
export const parseHospitalTreatmentVo = (
  data: FaceToFaceTreatmentKeywordsQuery,
): Array<HospitalTreatmentVo> => {
  return data.faceToFaceTreatmentKeywords.map((data) => {
    return { ...data };
  });
};
